// extracted by mini-css-extract-plugin
module.exports = {"divider":"ServiceFeeSettings_divider__dn8Rx","label":"ServiceFeeSettings_label__22meL","gbl_fee":"ServiceFeeSettings_gbl_fee__3XyHG"};